import Component from '@cell/cell-core/component/component';
import './active-filter-value.scss';

class ActiveFilterValue extends Component {
  constructor() {
    super();

    this.handleRemoveClick = this.handleRemoveClick.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.remove', this.handleRemoveClick);
  }

  handleRemoveClick() {
    this.emit('remove', { url: this.parsedDataset.urlToRemove });
  }
}

customElements.define('active-filter-value', ActiveFilterValue);
